export enum HospitalPrescriptionRefillStatus {
  Undefined = 0,
  PendingPickup = 1,
  ReadyforPickup = 2,
  Fulfilled = 3,
  Cancelled = 4,
  Abandoned = 5,
  PendingCheckout = 6,
}

export namespace HospitalPrescriptionRefillStatus {
  export const statusFormattedName = (status: string | number | undefined) => {
    if (typeof status === 'number')
      status = HospitalPrescriptionRefillStatus[status];
    if (!status) return 'Unknown';

    switch (status) {
      case 'PendingPickup':
        return 'Pending Pickup';
      case 'PendingCheckout':
        return 'Pending Checkout';
      case 'ReadyforPickup':
        return 'Ready for Pickup';
      default:
        return status; // Fulfilled, Cancelled, Abandoned
    }
  };
}
